var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BlogHero',{attrs:{"title":_vm.heading,"summary":_vm.description,"src":"/img/banners/about.jpg","credit":{}}}),_vm._v(" "),_c('About')],1)}
var staticRenderFns = []

export { render, staticRenderFns }